import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ISelectionItem } from '@app/models/selection-item';
import { TranslateService } from '@ngx-translate/core';

export interface SelectDialogData {
  items: ISelectionItem[],
  selectedOption?: any,
  placeholder?: string,
  translatePath?: string
}

@Component({
  selector: 'kt-select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: ['./select-dialog.component.scss']
})
export class SelectDialogComponent implements OnInit {

  items: ISelectionItem[] = [];
  placeholderString: string = '';
  selectedOption: any = null;
  translatePath: string = '';

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<SelectDialogComponent>,   
    @Inject(MAT_DIALOG_DATA) public data?: SelectDialogData,
  ) {
  }

  ngOnInit() {
    if (this.data) {
      this.placeholderString = this.data.placeholder || '';
      this.translatePath = this.data.translatePath || '';
      this.items = this.data.items || [];
      this.selectedOption = this.data.selectedOption || null;

    }
    if (this.translatePath && this.items.length)
      this.items.forEach(item => item.description = this.translate.instant(this.translatePath + '.' + item.description));
  }

}
